import ApiService from './ApiService'

export const ReportTemplatesService = {

  baseURL: process.env.VUE_APP_REPORTS_URL,
  baseAuthUrl: process.env.VUE_APP_AUTH_URL,

  query (params) {
    return ApiService.query(`${this.baseURL}/templates`, params)
  },

  store (params) {
    return ApiService.post(`${this.baseURL}/templates`, params)
  },

  update (resource, params) {
    return ApiService.put(`${this.baseURL}/templates/${resource}`, params)
  },

  destroy (resource) {
    return ApiService.delete(`${this.baseURL}/templates/${resource}`)
  },

  generateReports (resource, params) {
    return ApiService.post(`${this.baseURL}/templates/${resource}/generate`, params)
  },

  submitAdjusttReport (resource, data) {
    return ApiService.post(`${this.baseURL}/templates/${resource}/generateAdjustt`, data,
      { responseType: 'blob' })
  },

  // TODO: Refactor code to work with this service as well (response type blob)
  // generateReportsAdjustt (resource, params) {
  //   return ApiService.post(`${this.baseURL}/template/${resource}/generateAdjustt`)
  // }
  loadFacilities (resource) {
    return new Promise((resolve, reject) => {
      ApiService.get(`${this.baseAuthUrl}${resource}`)
        .then(response => resolve(response.data.data))
        .catch(err => reject(err))
    })
  },
  loadClusters (resource) {
    return new Promise((resolve, reject) => {
      ApiService.get(`${this.baseAuthUrl}${resource}`)
        .then(response => resolve(response.data.data))
        .catch(err => reject(err))
    })
  }
}

export const ReportsService = {

  baseURL: process.env.VUE_APP_REPORTS_URL,

  update (resource, params) {
    return ApiService.patch(`${this.baseURL}/reports/${resource}`, params)
  },

  bulkLock (params) {
    return ApiService.patch(`${this.baseURL}/reports/bulk-lock`, params)
  },

  downloadExcel (reportId) {
    return ApiService.blob(`${this.baseURL}/reports/${reportId}/download-excel`)
  },

  submitExcel (reportId, data) {
    return ApiService.post(`${this.baseURL}/reports/${reportId}/upload-excel`, data,
      { headers: { 'Content-Type': 'multipart/form-data' } })
  },

  delete (reportId) {
    return ApiService.delete(`${this.baseURL}/reports/${reportId}`)
  }
}
